import { US, CANADA } from '../value/constants';
import { ContentValueTrafficValue } from 'types';

const getRegionalInfo = (region: string) => {
  if (region === US) {
    return 'us';
  } else if (region === CANADA) {
    return 'canada';
  }
  return 'all';
};

interface TrafficValueType extends ContentValueTrafficValue {
  [index: string]: number | 'ContentValueTrafficValue' | undefined;
}

const regionalTrafficValAvg = (region: string, trafficValAvg: TrafficValueType) => {
  const regionalValue = `avg${capitalizeFirstLetter(getRegionalInfo(region))}Traffic`;
  return trafficValAvg[regionalValue] as number;
};

const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export { getRegionalInfo, regionalTrafficValAvg };
